const getTabLabel = (name) => {
  return name === "Regular Season" ? "All" : name;
};
export {
  getTabLabel
};
